import { HOME_SEO } from '~/src/lib/seo/productCategoryMetadata'
import { DEFAULT_OG_IMAGE } from '@dupe/common/constants'

export const defaultTitle = HOME_SEO.title
export const description = HOME_SEO.description

const config = {
  defaultTitle,
  titleTemplate: '%s | Dupe.com',
  description,
  // canonical is set dynamically in _app.tsx via router.asPath
  openGraph: {
    title: defaultTitle,
    description: description,
    type: 'website',
    site_name: 'Dupe.com',
    images: [
      {
        url: DEFAULT_OG_IMAGE,
        width: 1200,
        height: 630,
        alt: 'Dupe.com - AI Dupe Finder',
      },
    ],
  },
  twitter: {
    handle: '@dupedotcom',
    site: '@dupedotcom',
    cardType: 'summary_large_image',
  },
}

export default config
